import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import chat from './modules/chat'
const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  modules: {
    app,
    session,
    account,
    user,
    role,
    tenant,
    chat
  },
  getters: {
    chatMesList: () => chat.state.chatMesList
  }
})

export default store
